import React from "react";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid/Grid";

import { Acknowledgement } from "../../../UI/OnboardBar";

import OnboardManualFields from "../../../OnboardManualFields";

import { portfolioAction } from "../../../../actions";

import {
  AccountOwners,
  AdvisorFee,
  BDRepCode, CustodialPrimaryAccountHolder,
  Custodian,
  FundingViaTransfer,
  PershingTPA,
  RegistrationType,
  SelectACHRequired,
  SystemicIRADistributions,
  Trusts,
} from "../Fields";

import { withStyles } from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import CurrencyNumber from "../../../UI/CurrencyNumber";
import DownloadDisclosure from "../DownloadDisclosure";
import EmailDisclosure from "../EmailDisclosure";
import Link from "react-router-dom/es/Link";
import { getValidAdvisorFees } from "../../../../utilities/validators";
import {DownloadPDFButton} from "../../../../containers/HouseholdDetail/components";
import {OnboardingBypasser} from "../../../../utilities/onboardingBypass";

const otherCustodianStyles = {
  marginBottom: 10,
  fontSize: 14,
  textAlign: "justify",
};

const styles = (theme) => ({
  creatableSelectWrapper: {
    "& .MuiInputBase-input": {
      minHeight: 40,
    },
  },
  ctaWrapper: {
    padding: "20px 0",
    textAlign: "right",
    "& button": {
      marginLeft: 20,
    },
  },
  onboardingSummaryTable: {
    width: "80%",
    margin: "20px 0",
    background: theme.palette.secondary.offWhite,
    "& th": {
      fontSize: 13,
      color: theme.palette.primary.main,
    },
    "& td": {
      fontSize: 12,
    },
  },
  pershingFieldsWrapper: {
    border: `1px solid ${theme.palette.grey["A200"]}`,
    position: "relative",
    padding: 20,
    minHeight: 305,
    "& fieldset": {
      display: "block",
    },
    "& .portfolio-name": {
      position: "absolute",
      top: -16,
      left: 10,
      background: theme.palette.common.white,
      padding: "0 10px",
      fontSize: 18,
    },
  },
});

class OnboardPortfolios extends React.Component {
  state = {
    acknowledged: false,
    custodianId: null,
    step: 1,
    activePortfolioStep: 0,
    allowAcknowledgement: false,
    bdRepCode:
      (this.props.household.currentHousehold &&
        this.props.household.currentHousehold.RepCode &&
        this.props.household.currentHousehold.RepCode.bdRepCode) ||
      null,
    bdRepCodeId:
      (this.props.household.currentHousehold &&
        this.props.household.currentHousehold.RepCode &&
        this.props.household.currentHousehold.RepCode.id) ||
      null,
    selectedPortfolioParameters: this.props.selectedPortfolios.map((p) => {
      const {
        portfolioAdvisorFeeRates,
        fee: {
          advisorFeeRate,
          advisorDefaultFeeRate
        },
      } = this.props;

      return {
        portfolioId: p.uuid,
        ACHRequired: false,
        accountNumber: null,
        fundingViaTransfer: false,
        primaryAsAccountOwner: true,
        registrationType: {
          name: "",
          referenceKey: ""
        },
        systemicIRADistributions: false,
        trust: "",
        trustee: null,
        custodialAccountHolder: {
          accountHolderFirstName: '',
          accountHolderLastName: '',
          accountHolderName: '',
        },
        erisaTPA: null,
        advisorFee: getValidAdvisorFees(
          portfolioAdvisorFeeRates[p.uuid],
          advisorFeeRate,
          advisorDefaultFeeRate,
        ),
      };
    }),
  };

  setCustodian = (custodianId) => {
    const currentHouseholdHasRepCode =
    !!(this.props.household && this.props.household.currentHousehold && this.props.household.currentHousehold.RepCode);
    if (currentHouseholdHasRepCode) {
      this.setState({
        custodianId
      });
    } else {
      this.setState({
        custodianId,
        bdRepCode: null,
        bdRepCodeId: null,
      });
    }

  };
  setAcknowledged = (acknowledged) => {
    this.setState({ acknowledged });
  };
  setSkipToStep = (step) => (e) => {
    this.setState({ step });
  };
  setPortfolioStep = (step) => (e) => {
    this.setState({ activePortfolioStep: step });
  };
  setBdRepCode = (bdRepCode) => {
    console.log(bdRepCode);
    this.setState({
      bdRepCode: bdRepCode ? bdRepCode.repCode : null,
      bdRepCodeId: bdRepCode ? bdRepCode.id : null,
    });
  };

  setRegistrationType = (portfolioId) => (registrationType) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).registrationType =
        registrationType;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setACHRequired = (portfolioId) => (ACHRequired) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).ACHRequired =
        ACHRequired;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setFundingViaTransfer = (portfolioId) => (fundingViaTransfer) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).fundingViaTransfer =
        fundingViaTransfer;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setSystemicIRADistributions = (portfolioId) => (systemicIRADistributions) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find(
        (p) => p.portfolioId === portfolioId
      ).systemicIRADistributions = systemicIRADistributions;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setPrimaryAsAccountOwner = (portfolioId) => (primaryAsAccountOwner) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).primaryAsAccountOwner =
        primaryAsAccountOwner;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setErisaTPA = (portfolioId) => (erisaTPA) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).erisaTPA = erisaTPA;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setTrustees = (portfolioId) => (trusteeMode) => {
    // trusteeMode:
    // 0: primary
    // 1: secondary
    // 2: both
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).trustee = trusteeMode;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setAccountNumber = (portfolioId) => (accountNumber) => {
    let an =
      accountNumber === undefined || accountNumber === ""
        ? null
        : accountNumber;
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).accountNumber = an;
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setTrust = (portfolioId) => (trust) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).trust = trust
        ? trust.value
        : "";
      return {
        selectedPortfolioParameters: params,
      };
    });
  };

  setCustodialPrimaryAsAccountHolder = (portfolioId) => (accountHolder) => {
    this.setState((prevState) => {
      const params = [...prevState.selectedPortfolioParameters];
      params.find((p) => p.portfolioId === portfolioId).custodialAccountHolder = accountHolder;
      return {
        selectedPortfolioParameters: params,
      };
    });
  }

  editAdvisorFee = (portfolio) => (e) => {
    this.props.history.push(
      `/Portal/household/${portfolio.Household.id}/portfolio/${portfolio.uuid}?editFee=1`
    );
  };

  enableAcknowledgementCheckbox = () => {
    this.setState({ allowAcknowledgement: true });
  };

  onboard = () => {
    const { custodianMap, household, dispatch } = this.props;

    const { custodianId, selectedPortfolioParameters, bdRepCode, bdRepCodeId } =
      this.state;

    const custodian = custodianMap[custodianId];
    dispatch(
      portfolioAction.onboardMultiplePortfolios({
        custodian: custodian,
        householdId: household.currentHousehold.id,
        bdRepCode,
        bdRepCodeId,
        selectedPortfolioParameters,
      })
    );
  };

  isIRA = (registrationType) =>
    [
      "Traditional IRA",
      "Traditional IRA.Maridea",
      "Roth IRA",
      "Roth IRA.Maridea",
      'Inherited Roth IRA',
      'Inherited Roth IRA.Maridea',
      'Inherited Traditional IRA',
      'Inherited Traditional IRA.Maridea',
    ].includes(registrationType.referenceKey);

  isJoint = (registrationType) =>
    [
      "Joint Account",
      "Joint Account.Maridea",
      "Joint Account TOD",
      "Joint Account TOD.Maridea",
      "LPOA (Joint/Joint TOD)",
      "LPOA (Joint/Joint TOD).Maridea"
    ].includes(registrationType.referenceKey);

  isTrust = (registrationType) => ["Trust", "Trust.Maridea", "LPOA Trust"].includes(registrationType.referenceKey);

  isCustodial = (registrationType) => ["Custodial", "Custodial.Maridea", "LPOA Custodial"].includes(registrationType.referenceKey);

  isPCRA = (registrationType) => ["401k (PCRA)"].includes(registrationType.referenceKey);

  isTOD = (registrationType) =>
    [
      "Individual TOD",
      "Individual TOD.Maridea",
      "Joint Account TOD",
      "Joint Account TOD.Maridea",
    ].includes(registrationType.referenceKey);

  onCloseOnboardingInstruction = () => {
    this.props.onClose();
    if (this.props.callbacks) {
      this.props.callbacks();
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { custodianMap, quik, dispatch, onClose, hideCloseBtn } = this.props;

    if (quik.pending && !nextProps.quik.pending && !nextProps.quik.error) {
      if (
        nextProps.quik.onboardStyle === 'do' &&
        nextProps.quik.appUrl &&
        nextProps.quik.doSessionId
      ) {
        let doRoute = `/Portal/household/${
          this.props.household.currentHousehold.id
        }/onboard/${nextProps.quik.doSessionId}`;

        if (nextProps.quik.portfolioIds.length === 1) {
          doRoute += `?portfolioId=${nextProps.quik.portfolioIds[0]}`
        }
        this.props.history.push(doRoute);
      }
      if (
        nextProps.quik.onboardStyle !== 'do' &&
        nextProps.quik.html &&
        nextProps.quik.id
      ){
        const quikId = nextProps.quik.id;
        window.localStorage.setItem('quikform', JSON.stringify(nextProps.quik));
        const tab = window.open(`/Portal/onboard?quikId=${encodeURIComponent(quikId)}`, '_blank');
        if (!tab) {
          console.log('popup blocked')
          // window.location.href = `/Portal/onboard?quikId=${encodeURIComponent(quikId)}`;
        }
      }
      dispatch(portfolioAction.resetQuikFormData());

      const custodian = custodianMap[this.state.custodianId];
      if (
        custodian &&
        custodian.onboardingInstruction.enabled &&
        custodian.onboardingInstruction.instructionContent
      ) {
        this.setState({step: 4})
        hideCloseBtn();
      } else {
        onClose();
        if (this.props.callbacks && nextProps.quik.onboardStyle !== 'do') {
          this.props.callbacks();
        }
      }
    }
  }

  render() {
    const {
      custodianMap,
      custodians,
      selectedPortfolios,
      classes,
      quik,
      repCodes,
      household,
      brokerDealer,
      userCustodianFees,
      user
    } = this.props;

    const {
      custodianId,
      acknowledged,
      bdRepCodeId,
      step,
      activePortfolioStep,
      selectedPortfolioParameters,
      allowAcknowledgement,
    } = this.state;

    // dynamic form state
    const custodian = custodianMap[custodianId];
    const userCustodianIds = Object.keys(userCustodianFees).map((id) =>
      Number(id)
    );
    const userCustodians = custodians.filter((custodian) => {
      return userCustodianIds.indexOf(custodian.id) !== -1;
    });

    // const usePasOnboardingStrategy = custodian && custodian.onboardingStrategy === "pershing";
    const useDO = custodian &&
                  custodian.onboardingRules.digitalOnboardingEnabled &&
                  custodian.onboardingRules.digitalOnboardingServiceProvider === 'do';

    const primary = this.props.household.currentHousehold.Clients.map(
      (c) => c.profile
    ).find((p) => p.primary);
    const spouse = this.props.household.currentHousehold.Clients.map(
      (c) => c.profile
    ).find((p) => !p.primary);

    const PershingFields = (portfolio) => {
      const portfolioId = portfolio.uuid;
      const householdMembers = [primary, spouse];

      const { selectedPortfolioParameters } = this.state;
      const { registrationType, erisaTPA, advisorFee } =
        selectedPortfolioParameters.find((p) => p.portfolioId === portfolioId);
      const isJoint = this.isJoint(registrationType);
      const isIRA = this.isIRA(registrationType);
      const isTrust = this.isTrust(registrationType);
      const isERISA = portfolio.metadata.managerType === "ERISA";
      const isCustodial = this.isCustodial(registrationType);
      // const isTOD = this.isTOD(registrationType);

      // trustOptions is an array contains no duplicate items, no empty string or undefined value
      const trustOptions = [
        ...new Set(
          selectedPortfolioParameters
            .map((p) => p.trust)
            .filter((t) => t && t !== "")
        ),
      ];

      return (
        <React.Fragment>
          <Typography className={"portfolio-name"}>{portfolio.name}</Typography>
          <Grid item xs={6} style={{ paddingRight: 30 }}>
            {isERISA && (
              <PershingTPA onChange={this.setErisaTPA(portfolioId)} />
            )}
            <RegistrationType
              onChange={this.setRegistrationType(portfolioId)}
              selectedAccountType={registrationType}
              isERISA={isERISA}
              onboardingStrategy={custodian.onboardingStrategy}
              erisaTPA={erisaTPA}
            />
            {
              !!registrationType.referenceKey &&
              <React.Fragment>
                {isJoint && !spouse && (
                  <FormHelperText error>
                    Please
                    <Link
                      to={`/Portal/household/${this.props.household.currentHousehold.id}/client`}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        style={{ margin: "0 14px", fontSize: 12 }}
                      >
                        update
                      </Button>
                    </Link>
                    your client profile to add your spouse.
                  </FormHelperText>
                )}
                {isTrust && (
                  <div className={classes.creatableSelectWrapper}>
                    <Trusts
                      onChange={this.setTrust(portfolioId)}
                      trustOptions={trustOptions}
                    />
                  </div>
                )}
                {!isJoint && (
                  <AccountOwners
                    householdMembers={householdMembers}
                    allowBoth={isTrust || isERISA}
                    setAccountOwner={this.setPrimaryAsAccountOwner(portfolioId)}
                    setTrustees={this.setTrustees(portfolioId)}
                  />
                )}
                {isIRA && !useDO && (
                  <SystemicIRADistributions
                    onChange={this.setSystemicIRADistributions(portfolioId)}
                  />
                )}
                {
                  isCustodial && (
                    <CustodialPrimaryAccountHolder
                      onChange={this.setCustodialPrimaryAsAccountHolder(portfolioId)}
                    />
                  )
                }
              </React.Fragment>
            }
          </Grid>
          {
            !!registrationType.referenceKey &&
            <Grid item xs={6}>
              {!isERISA && !useDO && (
                <SelectACHRequired onChange={this.setACHRequired(portfolioId)} />
              )}
              {
                !useDO &&
                <FundingViaTransfer
                  onChange={this.setFundingViaTransfer(portfolioId)}
                />
              }
              <AdvisorFee
                advisorFee={advisorFee}
                onClick={this.editAdvisorFee(portfolio)}
              />
            </Grid>
          }

        </React.Fragment>
      );
    };

    const SchwabFields = (portfolio) => {
      const portfolioId = portfolio.uuid;
      const householdMembers = [primary, spouse];
      const { selectedPortfolioParameters } = this.state;
      const { registrationType, erisaTPA } = selectedPortfolioParameters.find(
        (p) => p.portfolioId === portfolioId
      );
      const isJoint = this.isJoint(registrationType);
      // const isIRA = this.isIRA(registrationType);
      const isTrust = this.isTrust(registrationType);
      const isERISA = portfolio.metadata.managerType === "ERISA";
      const isCustodial = this.isCustodial(registrationType);
      // const isPCRA = this.isPCRA(registrationType);

      // trustOptions is an array contains no duplicate items, no empty string or undefined value
      const trustOptions = [
        ...new Set(
          selectedPortfolioParameters
            .map((p) => p.trust)
            .filter((t) => t && t !== "")
        ),
      ];

      return (
        <React.Fragment>
          <Typography className={"portfolio-name"}>{portfolio.name}</Typography>
          <Grid item xs={12} style={{ paddingRight: 30 }}>
            <RegistrationType
              onChange={this.setRegistrationType(portfolioId)}
              selectedAccountType={registrationType}
              isERISA={isERISA}
              erisaTPA={erisaTPA}
              onboardingStrategy={custodian.onboardingStrategy}
            />
            {
              !!registrationType.referenceKey &&
              <React.Fragment>
                {isJoint && !spouse && (
                  <FormHelperText error>
                    Please
                    <Link
                      to={`/Portal/household/${this.props.household.currentHousehold.id}/client`}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        style={{ margin: "0 14px", fontSize: 12 }}
                      >
                        update
                      </Button>
                    </Link>
                    your client profile to add your spouse.
                  </FormHelperText>
                )}
                {isTrust && (
                  <div className={classes.creatableSelectWrapper}>
                    <Trusts
                      onChange={this.setTrust(portfolioId)}
                      trustOptions={trustOptions}
                    />
                  </div>
                )}
                {registrationType && !isJoint && (
                  <AccountOwners
                    householdMembers={householdMembers}
                    allowBoth={isTrust || isERISA}
                    setAccountOwner={this.setPrimaryAsAccountOwner(portfolioId)}
                    setTrustees={this.setTrustees(portfolioId)}
                  />
                )}
                {
                  isCustodial && (
                    <CustodialPrimaryAccountHolder
                      onChange={this.setCustodialPrimaryAsAccountHolder(portfolioId)}
                    />
                  )
                }
              </React.Fragment>
            }
          </Grid>
        </React.Fragment>
      );
    };

    const OtherCustodianFields = (portfolioId) => (
      <OnboardManualFields
        portfolioId={portfolioId}
        onChange={this.setAccountNumber(portfolioId)}
        otherCustodianStyles={otherCustodianStyles}
      />
    );

    const OnboardingSummary = () => {
      return (
        <React.Fragment>
          <Grid item xs={12}>
            <Typography>
              Here is a summary of the portfolios that are being onboarded
              today:
            </Typography>
            <Table className={classes.onboardingSummaryTable}>
              <TableHead>
                <TableRow>
                  <TableCell>Portfolio Name</TableCell>
                  <TableCell>Investment Amount</TableCell>
                  <TableCell>Registration Type</TableCell>
                  <TableCell>Cy Portfolio</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedPortfolioParameters.map((spp, index) => {
                  const portfolio = selectedPortfolios.find(
                    (p) => p.uuid === spp.portfolioId
                  );
                  return (
                    <TableRow key={spp.portfolioId || index}>
                      <TableCell>{portfolio.name}</TableCell>
                      <TableCell>
                        {portfolio.metadata && (
                          <CurrencyNumber
                            value={portfolio.metadata.initialInvestment}
                          />
                        )}
                      </TableCell>
                      <TableCell>{spp.registrationType.name}</TableCell>
                      <TableCell>{portfolio.metadata.displayName}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </React.Fragment>
      );
    };

    const InvalidBrokerDealer = ({ brokerDealerName }) => (
      <Typography color="error" gutterBottom={true}>
        You Broker Dealer <b>{brokerDealerName}</b> does not have a solicitor's
        agreement signed. Please contact support.
      </Typography>
    );

    if (step === 1) {
      const nextStep = custodian && custodian.onboardingRules.digitalOnboardingEnabled ? 2 : 3;
      return (
        <React.Fragment>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {
                OnboardingBypasser.allowPacerAdvisors(user) ? null :
                // Validate if broker dealer has an agreement with WBI
                (brokerDealer && !brokerDealer.verified) &&
                <InvalidBrokerDealer brokerDealerName={brokerDealer.name} />

              }

              <Custodian
                custodians={userCustodians}
                onChange={this.setCustodian}
                selectedCustodianId={custodianId}
                currentHouseholdRepCode={
                  household.currentHousehold &&
                  household.currentHousehold.RepCode
                }
              />
            </Grid>

            <Grid item xs={12}>
              <BDRepCode
                onChange={this.setBdRepCode}
                bdRepCodes={repCodes}
                selectedBdRepCodeId={bdRepCodeId}
                custodians={userCustodians}
                selectedCustodianId={custodianId}
                currentHouseholdRepCode={
                  household.currentHousehold &&
                  household.currentHousehold.RepCode
                }
              />
            </Grid>
          </Grid>
          <div className={classes.ctaWrapper}>
            <Button
              disabled={
                OnboardingBypasser.allowPacerAdvisors(user) ? false :
                !custodian || !bdRepCodeId ||
                (brokerDealer && !brokerDealer.verified)
              }
              variant="contained"
              color="primary"
              onClick={this.setSkipToStep(nextStep)}
            >
              Continue
            </Button>
          </div>
        </React.Fragment>
      );
    }

    if (step === 2) {
      return (
        <React.Fragment>
          <Stepper activeStep={activePortfolioStep} alternativeLabel>
            {selectedPortfolios.map((p, index) => (
              <Step
                key={p.uuid || index}
                completed={activePortfolioStep > index}
              >
                <StepLabel>
                  <Typography variant="body1">{p.name}</Typography>
                </StepLabel>
              </Step>
            ))}
            <Step completed={activePortfolioStep === selectedPortfolios.length}>
              <StepLabel>
                <Typography variant="body1">Summary</Typography>
              </StepLabel>
            </Step>
          </Stepper>
          <Typography
            variant="body2"
            align={"center"}
            style={{ marginBottom: 12 }}
          >
            {activePortfolioStep < selectedPortfolios.length
              ? `Step ${activePortfolioStep + 1}: Details about your ${
                  selectedPortfolios[activePortfolioStep].name
                } Portfolio`
              : `Step ${activePortfolioStep + 1}: Summary`}
          </Typography>
          {/* map fields based on type of onboardingStrategy */}
          {selectedPortfolios.map((p, i) =>
            custodian.onboardingStrategy === "pershing"
              ? activePortfolioStep === i && (
                  <Grid
                    container
                    key={p.uuid || i}
                    className={classes.pershingFieldsWrapper}
                  >
                    {PershingFields(p)}
                  </Grid>
                )
              : custodian.onboardingStrategy === "schwab"
              ? activePortfolioStep === i && (
                  <Grid
                    container
                    key={p.uuid || i}
                    className={classes.pershingFieldsWrapper}
                  >
                    {SchwabFields(p)}
                  </Grid>
                )
              : activePortfolioStep === i && (
                  <Grid container key={p.uuid || i}>
                    {OtherCustodianFields(p.uuid)}
                  </Grid>
                )
          )}
          {activePortfolioStep === selectedPortfolios.length &&
            OnboardingSummary()}

          <div className={classes.ctaWrapper}>
            {activePortfolioStep === 0 && (
              <Button
                onClick={this.setSkipToStep(1)}
                variant="outlined"
                color="primary"
                disabled={quik.pending}
              >
                {" "}
                Back{" "}
              </Button>
            )}
            {activePortfolioStep >= 1 &&
              activePortfolioStep <= selectedPortfolios.length && (
                <Button
                  onClick={this.setPortfolioStep(activePortfolioStep - 1)}
                  variant="outlined"
                  color="primary"
                  disabled={quik.pending}
                >
                  {" "}
                  Back{" "}
                </Button>
              )}
            {activePortfolioStep >= 0 &&
              activePortfolioStep < selectedPortfolios.length && (
                <Button
                  onClick={this.setPortfolioStep(activePortfolioStep + 1)}
                  variant="contained"
                  color="primary"
                  disabled={
                    (
                      !selectedPortfolioParameters[activePortfolioStep].registrationType
                    ) ||
                    (
                      this.isTrust(selectedPortfolioParameters[activePortfolioStep].registrationType) &&
                      selectedPortfolioParameters[activePortfolioStep].trust === ""
                    ) ||
                    (
                      this.isJoint(selectedPortfolioParameters[activePortfolioStep].registrationType) &&
                      !spouse
                    ) ||
                    (
                      this.isCustodial(selectedPortfolioParameters[activePortfolioStep].registrationType) &&
                      (
                        selectedPortfolioParameters[activePortfolioStep].custodialAccountHolder.accountHolderFirstName === '' ||
                        selectedPortfolioParameters[activePortfolioStep].custodialAccountHolder.accountHolderLastName === ''
                      )
                    )
                  }
                >
                  {" "}
                  Next{" "}
                </Button>
              )}
            {activePortfolioStep === selectedPortfolios.length && (
              <Button
                variant="contained"
                color="primary"
                onClick={this.setSkipToStep(3)}
              >
                Continue
              </Button>
            )}
          </div>
        </React.Fragment>
      );
    }

    if (step === 3) {
      const prevStep = custodian && custodian.onboardingRules.digitalOnboardingEnabled ? 2 : 1;
      return (
        <React.Fragment>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography>
                Please select from the below to review and furnish the necessary
                disclosures with your client. This is required in order to
                onboard the portfolio(s).
                <br />
                <br />
                <br />
                <br />
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <EmailDisclosure onEmailed={this.enableAcknowledgementCheckbox} />
              <DownloadDisclosure
                onDownloaded={this.enableAcknowledgementCheckbox}
              />
            </Grid>
            <Grid item xs={12}>
              <Acknowledgement
                onChange={this.setAcknowledged}
                disabled={!allowAcknowledgement}
              />
            </Grid>
          </Grid>
          <div className={classes.ctaWrapper}>
            <Button
              onClick={this.setSkipToStep(prevStep)}
              variant="outlined"
              color="primary"
              disabled={quik.pending}
            >
              {" "}
              Back{" "}
            </Button>
            <Button
              disabled={quik.pending || !acknowledged}
              onClick={this.onboard}
              variant={"contained"}
              color={"primary"}
            >
              {!quik.pending ? (
                "Confirm and Onboard"
              ) : (
                <CircularProgress size={20} />
              )}
            </Button>
            {quik.pending && (
              <Typography variant={"body1"} style={{ marginTop: 10 }}>
                Please do not refresh this page. Cy is working.
              </Typography>
            )}
            {
              quik.error && (
                <Typography variant={"body1"} color={'error'} style={{ marginTop: 10 }}>
                  Sorry, the onboarding request was not successful, please try again.
                </Typography>
              )
            }
          </div>
        </React.Fragment>
      );
    }

    if (step === 4) {
      const instructionContent =
        custodian &&
        custodian.onboardingInstruction.enabled &&
        custodian.onboardingInstruction.instructionContent;
      const portfolioIds = selectedPortfolios.map(p => p.uuid);

      if (!instructionContent) {
        return null
      }
      return (
        <React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  dangerouslySetInnerHTML={{ __html: instructionContent}}
                  paragraph={true}
                />
                <DownloadPDFButton
                  householdId={household.currentHousehold.id}
                  portfolioIds={portfolioIds}
                  labelText={"Download Cy Summary PDF"}
                />
              </Grid>
            </Grid>
          <div className={classes.ctaWrapper}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onCloseOnboardingInstruction}
            >
              Confirm and Close
            </Button>
          </div>
        </React.Fragment>
      )
    }
    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  const custodianMap = state.custodian.map;
  const custodians = Object.values(custodianMap).sort(function (a, b) {
    if (a.name > b.name) return 1;
    else if (a.name < b.name) return -1;
    else return 0;
  });
  const { portfolioAdvisorFeeRates } = state.fee;
  const quik = state.quik;
  const household = state.household;

  const repCodes = state.user.user.repCodes.map((src) => {
    return {
      id: src.id,
      repCode: src.bdRepCode,
      custodialRepCode: src.custodialRepCode,
      isValid: src.isValid,
    };
  });
  const { userCustodianFees } = state.fee;
  const ourUserCustodianFeesProps = userCustodianFees[state.user.user.id] || {};

  const brokerDealer = state.user.user.brokerDealer;
  const appName = state.app.appName;
  return {
    household,
    custodians,
    custodianMap,
    fee: state.fee,
    quik,
    portfolioAdvisorFeeRates,
    repCodes,
    brokerDealer,
    appName,
    userCustodianFees: ourUserCustodianFeesProps,
    user: state.user.user
  };
};

export default withStyles(styles)(connect(mapStateToProps)(OnboardPortfolios));



// WEBPACK FOOTER //
// ./src/components/OnboardPortfoliosDialog/components/OnboardPortfolios/index.jsx